import React, { useEffect, useState, useRef } from "react";
import FilterComponent from "../FilterComponent/FilterComponent";
import "./ChannelsAndPacksComponent.css";
import HdIcon from "../../../images/img/hd-icon.svg";
import SdIcon from "../../../images/img/sd-icon.svg";
import RightIcon from "../../../images/icons/right-icons.svg";
import FilterIcon from "../../../images/icons/filter-icon.svg";
import defaultBox from "../../../images/img/default-box.png";
import defaultChannel from "../../../images/img/default-channel.png";
import apiService from "../../APIService";
import PackDescriptionComponent from "../PackDesription/PackDescriptionComponent";
import ScrollerWithArrows from "../../../Simplify360Chat/CommonUtils/ScrollerWithArrows";
import $ from "jquery";
import _ from 'lodash';
export default function ChannelsAndPacksComponent(props) {
  //todo pack description component pending
  //todo onClick of view channel list component toggle PackDescription Componrnt with props
  //constants or variables
  const {
    channelsProps,
    packsProps,
    filters,
    selectedLanguagesProps,
    allLanguagesProps,
    selectedGenresProps,
    allGenresProps,
    filterTag,
    filterToggle,
    onClickSubmit,
    tag,
    code,
    text_data,
    selectedHd,
    prioratizePacks,
    filterShowOnlyChannels,
    showViewOnlyChannels,
  } = props;
  const channelRef = useRef(null);
  const packsRef = useRef(null);
  const confirmRef = useRef(null);
  const startingRef = useRef(null);
  //states

  const [applyFilterToggle, setApplyFilterToggle] = useState(false);
  const [channels, setChannels] = useState(channelsProps);
  const [packs, setPacks] = useState(packsProps);
  const [count, setCount] = useState(0);
  const [refresh, setRefres] = useState(false);
  const [selectedGenres, setSelectedGenres] = useState(selectedGenresProps);
  const [selectedLanguages, setSelectedLanguages] = useState(
    selectedLanguagesProps
  );
  const [allGenres, setAllGenres] = useState(allGenresProps);
  const [allLanguages, setAllLanguages] = useState(allLanguagesProps);
  const [enableDescriptionComponent, setEnableDescriptionComponent] = useState({
    toggle: false,
    data: null,
  });
  const [selectedPacks, setSelectedPacks] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [disabled, setDisabled] = useState(true);

  const [lastIndexChannel, setLastIndexChannel] = useState(
    channelsProps.length - 1
  );

  const [lastIndexPacks, setLastIndexPacks] = useState(packsProps?.length - 1);

  const [showChannelLeft, setShowChannelLeft] = useState(false);

  const [showChannelRight, setShowChannelRight] = useState(
    channelsProps.length > 3 ? true : false
  );

  const [showPackLeft, setShowPackLeft] = useState(false);

  const [showPackRight, setShowPackRight] = useState(
    packsProps?.length > 1 ? true : false
  );

  //useEffects
  useEffect(() => {
    //map through all channels and set a checked filed as false
    //map through all packs and set a checked filed as false
    channels.map((chan) => (chan.checked = false));
  }, []);

  useEffect(() => {
    packs?.map((pa) => (pa.checked = false));
  }, []);

  var selectedpackToSend = [];
  var selectedChannelsTosend = [];

  useEffect(() => {
    let selectedChannels =
      (channels &&
        channels?.filter((oneChannel) => oneChannel?.checked === true)) ||
      [];
    let selectedpacks =
      (packs && packs?.filter((onePack) => onePack?.checked === true)) || [];
    if (selectedChannels?.length === 0 && selectedpacks?.length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);

      selectedpackToSend = packs
        ?.filter((onePAck) => onePAck.checked === true)
        ?.map((onePack) => onePack.name);

      selectedChannelsTosend = channels
        ?.filter((oneChannel) => oneChannel.checked === true)
        ?.map((oneChannel) => oneChannel.name);
    }
  }, [channels, packs]);

  //functions
  const handleApplyFilters = () => {
    setApplyFilterToggle(!applyFilterToggle);
  };
  const onClickChannelHandler = (channel) => {
    var temp = [];
    if (channel.checked === false) {
      channel.checked = true;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    } else {
      channel.checked = false;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    }

    setChannels(temp);
  };

  const isSupportedImage = (imageLink) => {
    console.log(imageLink, "image link");
    if (imageLink.toString().includes(".gif")) {
      return imageLink;
    } else {
      return imageLink;
    }
  };

  const onPackClickHandler = (pack) => {
    var temp = [];
    if (pack.checked === false) {
      pack.checked = true;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    } else {
      pack.checked = false;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    }

    setPacks(temp);
  };

  const onConfirmHandler = () => {
    console.log("onConfirmHandler", code, tag);

    let tempselectedPacks = packs
      .filter((onePAck) => onePAck.checked === true)
      .map((onePack) => onePack);

    let tempselectedChannels = channels
      .filter((oneChannel) => oneChannel.checked === true)
      .map((oneChannel) => oneChannel);

    setSelectedChannels(tempselectedChannels);
    setSelectedPacks(tempselectedPacks);
    if (tempselectedPacks.length === 0 && tempselectedChannels.length === 0) {
      return;
    }

    onClickSubmit(
      code,
      {
        channelName: channels
          .filter((oneChannel) => oneChannel.checked === true)
          .map((oneChannel) => oneChannel.name),
        packName: packs
          .filter((onePAck) => onePAck.checked === true)
          .map((onePack) => onePack.name),
      },
      tag
    );

    filterToggle(true);

    localStorage.setItem(
      "selectedChannelsPAcks",
      JSON.stringify({
        channelName: tempselectedChannels,
        packName: tempselectedPacks,
      })
    );
  };

  const updateCount = (data) => {
    setCount(data);
    setRefres(!refresh);
  };

  const onClickFilterHandler = (code, data, tag) => {
    setApplyFilterToggle(false);
    if (!code) {
      console.error("ChannelsAndPacksComponent: code is null, skipping filter API call");
      return;
    }
    apiService.chatPost(code, data).then((response) => {
      var tempChannels = [];
      var tempPacks = [];
      tempChannels =
        response.data.chatResponse.entries[1].text_data?.channels?.channelList;

      tempChannels !== undefined &&
        tempChannels.map((chan) => (chan.checked = false));
      tempPacks =
        response.data?.chatResponse?.entries[1].text_data?.packsWithChannel
          ?.packList;

      tempPacks !== undefined && tempPacks.map((pa) => (pa.checked = false));
      //  var tempChannels=[]
      //  var tempPacks=[]
      //   tempChannels=response.data.chatResponse.entries[1].text_data?.channels?.channelList
      //   tempPacks=response.data.chatResponse.entries[1].text_data?.packsWithChannel?.packList
      //take tempChannels -> response.data.chatResponse.entries[1].text_data?.channels?.channelList
      //take tempPacks -> response.data.chatResponse.entries[1].text_data?..packsWithChannel?.packList
      //mapthrough channels and packs and add checked as false
      //TODO - Bharath - localLanguagesAndGenre update here as per Conversation component post function

      console.log(
        response.data.chatResponse?.entries[1].text_data,
        "HERE IN CHANNELS AND PACKS"
      );
      setChannels(tempChannels);
      setPacks(tempPacks);
      setAllLanguages(
        response.data.chatResponse.entries[1].text_data?.filter?.language
          ?.listOfLanguages
      );
      setSelectedLanguages(
        response.data.chatResponse.entries[1].text_data?.filter?.language
          ?.selectedLanguages
      );
      setAllGenres(
        response.data.chatResponse.entries[1].text_data?.filter?.genre
          ?.listOfGenre
      );
      setSelectedGenres(
        response.data.chatResponse.entries[1].text_data?.filter?.genre
          ?.selectedGenre
      );
      setRefres(!refresh);
      setRefres(!refresh);
    });
  };

  const enableDescription = (e, data) => {
    e.stopPropagation();
    localStorage.setItem("packDescription", JSON.stringify(data));
    setEnableDescriptionComponent({
      toggle: true,
      data: data,
    });
  };

  const selectDescription = (data) => {
    onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle: false,
      data: null,
    });
  };

  useEffect(() => {
    if (channels && channels.length > 0) {
      const element = document.getElementById("hscrollChannels");
  
      // Throttle the scroll handler
      const handleScroll = _.throttle(() => {
        let container = $(".channelsSliderContainer");
        let containerRect = container[0].getBoundingClientRect();
        let containerLeft = containerRect.left;
        let containerWidth = containerRect.width;
  
        let visibleStart = containerLeft;
        let visibleEnd = containerLeft + containerWidth;
  
        let lastCardElement = $(`#channelId-${lastIndexChannel}`);
        let lastCardRect = lastCardElement[0].getBoundingClientRect();
        let lastCardLeft = lastCardRect.left;
        let lastCardRight = lastCardLeft + lastCardRect.width;
  
        // Check if the last channel card is in view
        if (lastCardRight > visibleStart && lastCardLeft < visibleEnd) {
          setShowChannelRight(false);
        } else {
          setShowChannelRight(true);
        }
  
        let firstCardElement = $(`#channelId-0`);
        let firstCardRect = firstCardElement[0].getBoundingClientRect();
        let firstCardLeft = firstCardRect.left;
  
        // Check if the first channel card is out of view
        setShowChannelLeft(firstCardLeft < visibleStart);
  
      }, 100); // Throttle the function every 100ms
  
      element.addEventListener("wheel", handleScroll);
  
      return () => {
        element.removeEventListener("wheel", handleScroll);
      };
    }
  }, [channels, lastIndexChannel]);

  const getScrollValue = _.throttle(() => {
    let container = $(".packsSilderContainer");
    let containerRect = container[0].getBoundingClientRect();
    let containerLeft = containerRect.left;
    let containerWidth = containerRect.width;

    let visibleStart = containerLeft;
    let visibleEnd = containerLeft + containerWidth;

    let lastCardElement = $(`#packId-${packs.length - 1}`);
    let lastCardRect = lastCardElement[0].getBoundingClientRect();
    let lastCardLeft = lastCardRect.left;
    let lastCardRight = lastCardLeft + lastCardRect.width;

  
    if (lastCardRight > visibleStart && lastCardLeft < visibleEnd) {
      setShowPackRight(false); 
    } else {
      setShowPackRight(true);
    }

    let firstCardElement = $(`#packId-0`);
    let firstCardRect = firstCardElement[0].getBoundingClientRect();
    let firstCardLeft = firstCardRect.left;

    setShowPackLeft(firstCardLeft < visibleStart); 
  }, 100); 


  useEffect(() => {
    if (packs !== undefined && packs !== null && packs.length !== 0) {
      const element = document.getElementById("hscrollPacks");
      element.addEventListener("wheel", getScrollValue);

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [packs, getScrollValue]);

  return (
    <div>
      {enableDescriptionComponent.toggle && (
        <PackDescriptionComponent
          data={enableDescriptionComponent.data}
          closeDescriptionComponent={() => setEnableDescriptionComponent(false)}
          selectDesctipon={() => selectDescription()}
        />
      )}
     { !filterShowOnlyChannels && <div className="applyFilterContainer" ref={startingRef}>
        {applyFilterToggle && count > 0 && (
          <div key={count} id="filterCount">
            {count}
          </div>
        )}
        <div className="buttonContainer btn-animate chat-label">
          <img src={FilterIcon}></img>
          <span onClick={() => handleApplyFilters()}>Apply Filters</span>
        </div>
      </div>}
      <div className="filterContainer-packList">
        {applyFilterToggle ? (
          <FilterComponent
            filters={props?.filters}
            selectedLanguagesProps={selectedLanguages}
            allLanguagesProps={allLanguages}
            selectedGenresProps={selectedGenres}
            allGenresProps={allGenres}
            onClickFilter={onClickFilterHandler}
            filterTag={filterTag}
            filterToggle={filterToggle}
            setCount={updateCount}
            code={localStorage.getItem("filterCode")}
            selectedHd={selectedHd}
          />
        ) : null}
      </div>
      <div
        style={{
          display: "flex",
          width: "99%",
          flexDirection: prioratizePacks ? "column-reverse" : "column",
          paddingLeft: "1%",
        }}
      >
        {
          <div className="channelsListContainer">
            {!(
              channels !== undefined &&
              channels !== null &&
              channels.length !== 0
            ) ? (
              <div className="channelsHeaderContainer">
                <p>No Channels Available .</p>
              </div>
            ) : (
              <div className="channelsHeaderContainer">
                <p>Channels</p>
                <span></span>
              </div>
            )}
            {channels !== undefined &&
              channels !== null &&
              channels.length !== 0 && (
                <ScrollerWithArrows
                  dontShow={channels?.length === 0}
                  width="100%"
                  height="12rem"
                  isShowLeft={showChannelLeft}
                  isShowRight={showChannelRight}
                  setShowLeft={setShowChannelLeft}
                  setShowRight={setShowChannelRight}
                  lastIndex={lastIndexChannel}
                  parentId="hscrollChannels"
                  childId="channelId"
                  minimumValue={100}
                  maximumValue={105}
                >
                  <div
                    className="channelsSliderContainer"
                    id="hscrollChannels"
                    ref={channelRef}
                    width="100%"
                  >
                    {channels !== undefined &&
                    channels !== null &&
                    channels.length !== 0 ? (
                      channels.map((oneChannel, index) => (
                        <div
                          id={`channelId-${index}`}
                          key={index}
                          className="oneChannelBox"
                          onClick={showViewOnlyChannels ? undefined : () => onClickChannelHandler(oneChannel)}
                          style={{
                            border: oneChannel.checked
                              ? "1px solid #F07FC8"
                              : "none",
                            width: "30%",
                          }}
                        >
                          {!showViewOnlyChannels && (
                            <div className="oneChannel-checkbox">
                              <input
                                type="checkbox"
                                value={oneChannel.name}
                                checked={oneChannel.checked}
                              ></input>
                            </div>
                          )}
                          <div className="oneChannel-nameLogo">
                            <img
                              src={oneChannel.imageLink}
                              onError={(e) => (e.target.src = defaultChannel)}
                            ></img>
                            <p>{oneChannel.name}</p>
                          </div>
                          <div className="oneChannel-priceContainer">
                            <p>{oneChannel.description}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Channels</p>
                    )}
                  </div>
                </ScrollerWithArrows>
              )}
          </div>
        }
        {
          !filterShowOnlyChannels && <div className="packsListContainer">
            {!(packs !== undefined && packs !== null && packs.length !== 0) ? (
              <div className="packsList-header">
                <p>No Packs Available .</p>
              </div>
            ) : (
              <div className="packsList-header">
                <p>Packs with the channel</p>
                <span></span>
              </div>
            )}
            {packs !== undefined && packs !== null && packs.length !== 0 && (
              <ScrollerWithArrows
                dontShow={packs?.length === 0}
                width="100%"
                height="14rem"
                isShowLeft={showPackLeft}
                isShowRight={showPackRight}
                setShowLeft={setShowPackLeft}
                setShowRight={setShowPackRight}
                lastIndex={lastIndexPacks}
                parentId="hscrollPacks"
                childId="packId"
                minimumValue={240}
                maximumValue={950}
              >
                <div
                  className="packsSilderContainer"
                  id="hscrollPacks"
                  ref={packsRef}
                >
                  {packs.length !== 0 ? (
                    packs.map((onePack, index) => (
                      <div
                        key={index}
                        id={`packId-${index}`}
                        className="onePackBox"
                        onClick={showViewOnlyChannels ? undefined : () => onPackClickHandler(onePack)}
                        style={{
                          border: onePack.checked
                            ? "1px solid #F07FC8"
                            : "none",
                          width: "60%",
                        }}
                      >
                        <div className="onePackBox-checkbox">
                          {!showViewOnlyChannels && (
                            <input
                              type="checkbox"
                              value={onePack}
                              checked={onePack.checked}
                            ></input>
                          )}
                          <p>{onePack.name}</p>
                        </div>
                        <div className="onePackBox-price">
                          <p>{onePack.description}</p>{" "}
                        </div>
                        <div className="onePackBox-hdsd">
                          <div className="hdSdContainer">
                            <img src={HdIcon}></img>
                            <p>{onePack.noOfHdChannels}</p>
                          </div>
                          <div className="hdSdContainer">
                            <img src={SdIcon}></img>
                            <p>{onePack.noOfSdChannels}</p>
                          </div>
                        </div>
                        <div
                          className="onePackBox-link"
                          onClick={(e) => enableDescription(e, onePack)}
                        >
                          <p>View Channel List</p>
                          <img src={RightIcon}></img>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Packs</p>
                  )}
                </div>
              </ScrollerWithArrows>
            )}
          </div>
        }
      </div>
      {!showViewOnlyChannels && (
        <div className="confirmButtonContainer-channelsAndPacks" ref={confirmRef}>
          <a
            disabled={disabled}
            className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn "
            style={{
              borderRadius: "20px",
              textAlign: "center",
              fontSize: "12px",
              background: disabled ? "grey" : "red",
              // marginRight:"7%",
            }}
            onClick={() => onConfirmHandler()}
          >
            <p>Confirm</p>
          </a>
          {/* <a
          className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn back-styling"
          style={{
            borderRadius: "20px",
            textAlign: "center",
            fontSize: "12px",
          }}>
            <p>Back</p>
          </a> */}
        </div>
      )}
    </div>
  );
}
